import {Component, OnInit} from '@angular/core';
import {
  BreadcrumbMain,
  BreadcrumbSolutionMgrTransactionDataImport,
  CommonTransformationService,
  DateService,
  FileService,
  Format,
  GrowlType,
  PrimeNgConfig,
  PrimeNgSupportService,
  TableColumn,
  TableFormat,
  Validation
} from "@app/shared";
import {ConfirmationService, MenuItem} from "primeng/api";
import {GrowlService} from "@app/core";
import {InvoiceImportCCMapping, InvoiceImportItem} from "@app/shared/classes/dataimport/invoice-import-item";
import {ImportTemplateSubtype} from "@app/solution-manager/data-import/data-import";
import * as XLSX from "xlsx";
import {WorkSheet} from "xlsx";
import {TimeSheetImportCell} from "@app/shared/classes/quickbooks/qbuser-mapping";
import {plainToClass} from "class-transformer";
import {ImportDataService} from "@app/shared/import/data-import/import-data.service";

@Component({
  selector: 'app-invoice-import',
  templateUrl: './invoice-import.component.html',
  styleUrls: ['./invoice-import.component.css']
})
export class InvoiceImportComponent implements OnInit {

  public breadcrumb: MenuItem[] = [];

  Format: typeof Format = Format;
  PrimeNgConfig = PrimeNgConfig;
  Validation: typeof Validation = Validation;

  tableColumns: TableColumn[];
  importCells: InvoiceImportItem[] = []



  constructor() { }

  ngOnInit(): void {
    this.buildBreadCrumbs();
  }

  buildBreadCrumbs() {
    this.breadcrumb.push(BreadcrumbMain);
    this.breadcrumb.push(BreadcrumbSolutionMgrTransactionDataImport);
    this.breadcrumb.push({ label: 'Vendor Invoice Import', routerLink: '' });
  }



}
